export default {
  recordingStart: 'Recording start',
  recordingEnd: 'Recording end',
  duration: 'Duration',
  launchedBy: 'Launched by',
  eventsCount: 'Number of events recorded',
  concurrentRecordings: '{limit} concurrent recordings',
  subheader: 'Record all events from RabbitMQ',
  launch: 'Launch events recording',
  stop: 'Stop events recording',
  stopResending: 'Stop resending',
  inProgress: 'Recording in progress...',
  resendingInProgress: 'Resending in progress...',
  viewEventsAndPattern: 'View events and pattern',
  viewPattern: 'View pattern',
  eventsAreLoading: 'Events are loading',
  export: 'Export to JSON',
  applyEventFilter: 'Apply event filter',
  eventFilterApplied: 'Event filter applied',
  filterPatternOptional: 'Filter pattern is optional',
  delayBetweenEvents: 'Delay between events',
  resendEvents: 'Resend event | Resend events',
  selectedEventsAreResent: 'Selected events are resent',
  launchEventRecording: 'Launch events recording',
  launchEventRecordingDescription: 'Apply filter pattern for the events recorded',
  copyEvent: 'Copy event to clipboard',
  eventCopied: 'Event copied to clipboard',
};
